import { defineMessages } from 'react-intl'

export default defineMessages({
  welcomeMessage: {
    id: 'app.welcome.message',
    defaultMessage: 'Welcome to Pathway!',
  },
  welcomeDescription: {
    id: 'app.welcome.description',
    defaultMessage: 'Select one of the options from the left menu to get started',
  },
})
